module.exports = __webpack_public_path__ + "static/media/species2.3e57deca.jpg";